'use strict';

module.exports = function(classMap) {
  var res = [];

  if (!classMap) {
    return '';
  }

  Object.keys(classMap).map(function(className) {
    classMap[className] && res.push(className);
  });

  return res.length ? res.join(' ') : '';
};


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/classSet.js
 **/